<template>
  <div class="card">
    <div class="left">
      <div class="add" @click="addArea()" v-show="$ButtonShow('IAA_ADD_01')">新增区域</div>
      <div class="area" v-for="(item, index) in areaList" :key="index" @click="selectArea(index)">
        <div class="name" :class="{ active: currentIndex === index }">
          {{ item.areaName }}
        </div>
        <i class="el-icon-edit icon" @click="updateArea(item.areaId)" v-show="$ButtonShow('IAA_EDT_01')"></i>
        <i class="el-icon-delete-solid icon" @click="deleteArea(item.areaId)" v-show="$ButtonShow('IAA_DEL_01')"></i>
      </div>
      <img v-if="areaList.length === 0" src="@/assets/img/irrigation/nodata.png">
    </div>

    <div class="right">
      <!-- <div v-if="areaList.length > 0">
        <div class="header-left">
          <div v-for="(item, index) in infoList" :key="index">
            <span class="name">{{ item.name }}</span>
            <span class="count">{{ item.count }}</span>
          </div>
        </div>
        <div class="header-right">
          <div>{{ info.irrigationPlan && info.irrigationPlan.planName ? '当前计划' : '暂无计划' }}</div>
          <div class="plan" v-if="info.irrigationPlan && info.irrigationPlan.planName">
            <div>
              <span>计划名称</span>
              <span class="time">{{ info.irrigationPlan.planName || '-' }}</span>
            </div>
            <div class="planContent">
              <div v-if="info.irrigationPlan.planType === '1'">
                <span>开启时间</span>
                <span class="time">{{ info.irrigationPlan.executeTime || '-' }}</span>
              </div>
              <div v-if="info.irrigationPlan.planType === '2'">
                <span>触发阈值</span>
                <span class="time">{{ info.irrigationPlan.drought || '-' }}%</span>
              </div>
              <div>
                <span>最近一次开启时间</span>
                <span class="time">{{ info.irrigationNum.lastExecTime || '-' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div :style="{ height: '100%' }" id="container"></div>
      <div class="tips" v-show="areaList.length > 0">
        <el-checkbox-group v-model="checkValue" @change="drawMarkers">
          <el-checkbox v-if="soilList.length > 0" label="土壤监测"></el-checkbox>
          <el-checkbox v-if="waterList.length > 0" label="智慧水表"></el-checkbox>
          <el-checkbox v-if="electricityList.length > 0" label="智慧电表"></el-checkbox>
          <el-checkbox v-if="valveList.length > 0" label="电磁阀"></el-checkbox>
          <el-checkbox v-if="waterLyList.length > 0" label="流压监测"></el-checkbox>
        </el-checkbox-group>
      </div>
    </div>

    <div class="drawer" :class="drawer ? 'drawerShow' : 'drawerHide'">
      <template v-if="drawerData">
        <div class="info">
          <p class="title">智慧喷灌</p>
          <p class="text">设备名称<span>{{ drawerData.deviceName || '--' }}</span></p>
          <p class="text">设备串号<span>{{ drawerData.deviceNumber || '--' }}</span></p>
        </div>
        <template v-if="drawerData.type === 0">
          <div class="line">
            <div class="info1">
              <div v-for="(item, index) in soilDetailInfo" :key="index" class="info1_div" v-show="item.value !== '--'">
                <div class="icon"
                  :class="drawerData.deviceStatus === '1' ? (item.status === '正常' || item.status === '--') ? '' : 'warning' : 'gray'">
                  <span :class="['iconfont', item.icon]"></span>
                </div>
                <div>
                  <p class="title">{{ item.title }}</p>
                  <div class="info1_bottom">
                    <p class="value"
                      :class="drawerData.deviceStatus === '1' ? (item.status === '正常' || item.status === '--') ? '' : 'warning' : 'gray'">
                      {{ item.value }}</p>
                    <p class="status" v-if="item.title !== 'pH'"
                      :class="drawerData.deviceStatus === '1' ? (item.status === '正常' || item.status === '--') ? 'normal' : 'warning' : 'gray'">
                      {{ item.status }}</p>
                  </div>
                </div>
              </div>
            </div>
            <p class="date">更新时间：<span>{{ drawerData.collectTime || '--' }}</span></p>
          </div>
          <div class="line">
            <p class="data">最近3次数据上报</p>
            <el-table class="global-table" :data="tableData">
              <el-table-column label="温度(°C)" show-overflow-tooltip prop="temperature"></el-table-column>
              <el-table-column label="湿度(%)" show-overflow-tooltip prop="humidity"></el-table-column>
              <el-table-column label="上报时间" width="150" prop="collectTime"></el-table-column>
            </el-table>
          </div>
          <div class="line text-center">
            <el-button type="primary"
              @click="$router.push({ name: 'soilHistory', params: { deviceNumber: drawerData.deviceNumber } })">查看历史数据</el-button>
          </div>
        </template>
        <template v-else-if="drawerData.type === 3">
          <div class="line">
            <p class="data">操作</p>
            <div class=" text-center margin20">
              <el-button type="primary" v-show="$ButtonShow('IVE_EDT_02')"
                @click="operationIrrigation('1', drawerData.deviceNumber)"
                :disabled="drawerData.switchStatus === '1'">开启</el-button>
              <el-button type="primary" v-show="$ButtonShow('IVE_EDT_02')"
                @click="operationIrrigation('0', drawerData.deviceNumber)"
                :disabled="drawerData.switchStatus === '0'">关闭</el-button>
            </div>
            <el-form ref="addUserInfo" margin20 :model="irrigationInfo" label-width="120px">
              <el-form-item label="选择开启时间" prop="duration">
                <el-select v-model="irrigationInfo.duration" filterable allow-create default-first-option
                  placeholder="请选择开启时间" :disabled="drawerData.switchStatus === '1'">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
// import vjmap from 'vjmap'
// import 'vjmap/dist/vjmap.min.css'
import { vjEnv } from '@/utils/config'
import { getPolygons } from '@/utils/util'

const soilInfo = [
  {
    title: '温度(°C)',
    value: '-',
    icon: 'icon-wendu',
    status: ''
  },
  {
    title: '湿度(%)',
    value: '-',
    icon: 'icon-shidu',
    status: ''
  }
]

// const soilStatus = {
//   temperature: '',
//   humidity: ''
// }

export default {
  name: 'IrrigationArea',
  data () {
    return {
      areaList: [],
      currentIndex: 0,
      info: {
        irrigationPlan: {},
        irrigationNum: {}
      },
      valveList: [],
      soilList: [],
      waterList: [],
      electricityList: [],
      waterLyList: [],
      checkValue: ['土壤监测', '智慧水表', '智慧电表', '电磁阀', '流压监测'],
      drawer: false,
      tableData: [],
      drawerData: {
        deviceNumber: '',
        deviceName: '',
        areaId: '',
        deviceType: '',
        longitude: '',
        latitude: '',
        deviceStatus: '',
        type: -1
      },
      soilDetailInfo: {},
      // 土壤温湿
      onlineWenImg: require('@/assets/icon/soilHumidity/normal.svg'),
      onlineWenImgCursor: require('@/assets/icon/soilHumidity/normal-big.svg'),
      offWenImg: require('@/assets/icon/soilHumidity/offline.svg'),
      offImgWenCursor: require('@/assets/icon/soilHumidity/offline-big.svg'),
      alarmWenImg: require('@/assets/icon/soilHumidity/warning.svg'),
      alarmWenImgCursor: require('@/assets/icon/soilHumidity/warning-big.svg'),
      // 喷灌
      onlinePenImg: require('@/assets/icon/irrigation/icon_map_penguan_zaixian.svg'),
      offPenImg: require('@/assets/icon/irrigation/icon_map_penguan_lixian.svg'),
      onlinePenImgCursor: require('@/assets/icon/irrigation/icon_map_penguan_zaixian1.svg'),
      offPenImgCursor: require('@/assets/icon/irrigation/icon_map_penguan_lixian1.svg'),
      // 电
      onlineDianImg: require('@/assets/icon/irrigation/icon_map_dian_zaixian.svg'),
      offDianImg: require('@/assets/icon/irrigation/icon_map_dian_lixian.svg'),
      onlineDianImgCursor: require('@/assets/icon/irrigation/icon_map_dian_zaixian1.svg'),
      offDianImgCursor: require('@/assets/icon/irrigation/icon_map_dian_lixian1.svg'),
      // 水表
      onlineWaterImg: require('@/assets/icon/irrigation/icon_map_water_zaixian.svg'),
      onlineWaterImgCursor: require('@/assets/icon/irrigation/icon_map_water_zaixian1.svg'),
      offWaterImg: require('@/assets/icon/irrigation/icon_map_water_lixian.svg'),
      offWaterImgCursor: require('@/assets/icon/irrigation/icon_map_water_lixian1.svg'),
      // 流压监测
      onlineLyImg: require('@/assets/icon/water/normal.svg'),
      onlineLyImgCursor: require('@/assets/icon/water/normal-big.svg'),
      offLyImg: require('@/assets/icon/water/offline.svg'),
      offImgLyCursor: require('@/assets/icon/water/offline-big.svg'),
      alarmLyImg: require('@/assets/icon/water/warning.svg'),
      alarmLyImgCursor: require('@/assets/icon/water/warning-big.svg'),
      options: [{
        value: '10',
        label: '10分钟'
      }, {
        value: '15',
        label: '15分钟'
      }, {
        value: '20',
        label: '20分钟'
      }, {
        value: '40',
        label: '40分钟'
      }],
      // 电磁阀开启关闭状态加载
      valveStatusUpdateLoading: null,
      irrigationInfo: {
        duration: '10'
      }
    }
  },
  computed: {
    projectId () {
      return this.$route.query.projectId
    },
    areaId () {
      return this.areaList.length > 0 ? this.areaList[this.currentIndex].areaId : ''
    },
    mapCenter () {
      const project = this.projectInfo
      return [+project.longitude || 118.7587, +project.latitude || 31.9686]
    },
    projectInfo () {
      return this.$store.state.projectList.find(item => item.projectId === this.projectId) || {}
    },
    cadEpsg () {
      return this.projectInfo.epsg
    },
    isCad () {
      return !!this.projectInfo.cadId
    }
  },

  created () {
  },
  async mounted () {
    this._markers = []
    this._polygons = []
    try {
      await this.initMap()
    } catch (error) {
    }
    // 无cad则加载项目电子围栏
    if (!this.isCad) {
      this.loadProjectFence()
    }
    this.loadAreas()
  },
  beforeDestroy () {
    this.clearMarkers()
    this.clearPolygons()
    this._map && this._map.remove()
  },
  destroyed () {
  },
  methods: {
    // 选中区域
    selectArea (index) {
      this.currentIndex = index
      // 区域
      this.selectIrrigationAreaByAreaId()
      this.drawerClose()
    },

    // 获取区域
    loadAreas () {
      this.$axios.get(this.$apis.irrigation.selectIrrigationAreaByPage, {
        projectId: this.projectId
      }).then(res => {
        this.areaList = res.list || []
        if (this.areaList.length > 0) {
          this.selectIrrigationAreaByAreaId()
        } else {
          this.valveList = []
          this.soilList = []
          this.waterList = []
          this.electricityList = []
          this.waterLyList = []
          this.clearMarkers()
          this.clearPolygons()
        }
      })
    },

    addArea () {
      this.$router.push({
        path: '/irrigation2/addArea',
        query: {
          projectId: this.projectId
        }
      })
    },

    updateArea (areaId) {
      this.$router.push({
        path: '/irrigation2/updateArea' + areaId,
        query: {
          projectId: this.projectId
        }
      })
    },

    deleteArea (areaId) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.irrigation.deleteIrrigationArea, {
          areaId: areaId
        }).then(() => {
          this.currentIndex = 0
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.loadAreas()
        })
      })
    },
    async initMap () {
      // --高德地图(地图数据前端获取)--
      const svc = new vjmap.Service(vjEnv.serviceUrl, vjEnv.accessToken)
      this._svc = svc
      // 根据地图范围建立经纬度投影坐标系
      const prj = new vjmap.LnglatProjection()
      // wgs84坐标
      const coWgs84 = prj.toLngLat(this.mapCenter)
      // 把wgs84转成高德坐标坐标
      const coGCJ02 = vjmap.transform.convert(coWgs84, vjmap.transform.CRSTypes.WGS84, vjmap.transform.CRSTypes.GCJ02)
      // 地图对象
      this._map = new vjmap.Map({
        container: 'container', // DIV容器ID
        style: {
          version: svc.styleVersion(),
          glyphs: svc.glyphsUrl(),
          sources: {
            gaodeRoadSource: {
              type: 'raster',
              tiles: ['https://webrd02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}']
            },
            // 影像无文字注记
            gaodeImgSource: {
              type: 'raster',
              tiles: [
                'https://webst02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=6&x={x}&y={y}&z={z}'
              ]
            },
            // 影像文字注记
            gaodeImgSourceLabel: {
              type: 'raster',
              tiles: [
                'https://webst02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}'
              ]
            }
          },
          layers: [{
            id: 'gaodeRoad',
            type: 'raster',
            source: 'gaodeRoadSource'
          }, {
            id: 'gaodeImg',
            type: 'raster',
            source: 'gaodeImgSource',
            layout: {
              visibility: 'none'
            }
          }, {
            id: 'gaodeImgLabel',
            type: 'raster',
            source: 'gaodeImgSourceLabel',
            layout: {
              visibility: 'none'
            }
          }]
        },
        center: prj.toLngLat(coGCJ02),
        zoom: 15,
        pitch: 0,
        renderWorldCopies: false // 不显示多屏地图
      })

      this._map.on('click', e => {
        this.drawer = false
      })

      // 关联服务对象和投影对象
      this._map.attach(svc, prj)
      // 根据地图本身范围缩放地图至全图显示
      await this._map.onLoad()

      // 加载proj4库，用于坐标转换
      if (typeof proj4 !== 'object') {
        // 如果没有环境
        await vjmap.addScript([{
          src: 'https://vjmap.com/demo/js/proj4.min.js'
        }])
      }
      if (this.isCad) {
        const res = await this.openCAD()
        await this.addDefaultLayer(res)
      }
    },
    async addDefaultLayer (res) {
      const cadEpsg = this.cadEpsg
      const wmsUrl = this._svc.wmsTileUrl({
        mapid: this.projectInfo.cadId, // 地图id
        layers: res.layer, // 图层名称
        srs: 'EPSG:3857',
        crs: cadEpsg,
        webMapType: 'GCJ02' // 底图是高德地图，所以要选GCJ02,如果是天地图，可以不用填此项
      })
      this._map.addSource('wms-test-source', {
        type: 'raster',
        tiles: [
          wmsUrl
        ],
        tileSize: 256
      })
      this._map.addLayer({
        id: 'wms-test-layer',
        type: 'raster',
        source: 'wms-test-source',
        paint: { 'raster-opacity': 1 }
      }
      )
      await this.initEpsgProj({
        longitude: this.mapCenter[0],
        latitude: this.mapCenter[1]
      }, this.projectInfo.cadId)
      proj4.defs('EPSG:4326', '+proj=longlat +datum=WGS84 +no_defs +type=crs')
      // proj4.defs(cadEpsg, epsgArr[0].proj)
      // cad图坐标转web wgs84坐标，再转火星坐标（高德)
      const cadToWebCoordinate = point => {
        const co = proj4(cadEpsg, 'EPSG:4326', vjmap.geoPoint(point).toArray())
        // 把wgs84转成高德坐标坐标
        const dataaaa = vjmap.transform.convert(co, vjmap.transform.CRSTypes.WGS84, vjmap.transform.CRSTypes.GCJ02)
        return dataaaa
      }
      // // 火星坐标（高德)转web wgs84坐标转cad图坐标
      // const webTocadCoordinate = point => {
      //   const co = vjmap.transform.convert(point, vjmap.transform.CRSTypes.GCJ02, vjmap.transform.CRSTypes.WGS84)
      //   return proj4('EPSG:4326', cadEpsg, co)
      // }
      // 根据cad图的中心点，计算wgs84的中心点坐标
      const mapBounds = vjmap.GeoBounds.fromString(res.bounds)
      const cadCenter = mapBounds.center()
      // if (String(parseInt(cadCenter.x)).length === 8) {
      //   cadCenter.x = parseFloat(String(cadCenter.x).slice(2))
      // }
      // console.log('cadCenter', cadCenter)
      const webCenter = cadToWebCoordinate(cadCenter)
      // 把cad图的中点设置为地图的中心点
      console.log('webCenter', webCenter)
      this._map.setCenter(webCenter)
    },
    async openCAD (mapid, fileid) {
      const mapId = mapid || this.projectInfo.cadId
      console.log('mapId', mapId)
      console.log('fileid', fileid)
      this._svc.switchWorkspace(vjEnv.workspace)
      const res = await this._svc.openMap({
        fileid: fileid,
        mapid: mapId, // 地图ID,(请确保此ID已存在，可上传新图形新建ID)
        // mapopenway: vjmap.MapOpenWay.GeomRender, // 以几何数据渲染方式打开
        mapopenway: vjmap.MapOpenWay.Memory,
        style: vjmap.openMapDarkStyle() // div为深色背景颜色时，这里也传深色背景样式
      })
      return res
    },
    setPopupText (text) {
      if (text) {
        if (!this.popup) {
          this.popup = new vjmap.Popup({
            className: 'custom-popup',
            closeOnClick: false,
            closeButton: false
          })
            .setHTML(text)
            .setMaxWidth('500px')
            .trackPointer()
            .addTo(this._map)
        } else {
          this.popup.setHTML(text)
        }
      } else {
        // 如果为空时，则删除popup
        if (this.popup) {
          this.popup.setLngLat([0, 0]) // 取消trackPointer
          this.popup.remove()
          this.popup = null
        }
      }
    },
    async initEpsgProj ({ longitude, latitude }, mapId) {
      const metadata = await this._svc.metadata(mapId, 'v1')
      const x = longitude
      const y = latitude
      const cadX = String(parseInt(metadata.initCenterX))
      let res = []
      if (cadX.length === 8) {
        const proj = vjmap.transform.getEpsgParam(vjmap.transform.EpsgCrsTypes.CGCS2000, parseInt(cadX.slice(0, 2)))
        res.push(proj)
      } else {
        res = vjmap.transform.getEpsgCode([x, y], vjmap.transform.EpsgCrsTypes.CGCS2000, '')
      }
      console.log('pro4', res)
      for (const item of res) {
        if (item.proj) {
          proj4.defs(item.epsg, item.proj)
        }
        if (x < 180) {
          // 经纬度转 cad投影坐标
          item.convertCoordinate = proj4('EPSG:4326', item.epsg, [x, y])
        } else {
          // cad投影坐标转经纬度
          item.convertCoordinate = proj4(item.epsg, 'EPSG:4326', [x, y])
        }
      }
      return res
    },
    async getMapEpsg ({ longitude, latitude }, mapId) {
      const res = await this.initEpsgProj({ longitude, latitude }, mapId)
      const metadata = await this._svc.metadata(mapId, 'v1')
      const point1 = {
        x: parseFloat(metadata.initCenterX),
        y: parseFloat(metadata.initCenterY)
      }
      if (String(parseInt(point1.x)).length === 8) {
        point1.x = parseFloat(String(point1.x).slice(2))
      }
      for (const i of res) {
        const distance = this.calculateDistance(point1, {
          x: i.convertCoordinate[0],
          y: i.convertCoordinate[1]
        })
        i.distance = distance
      }
      const newEpsgArr = res.sort((a, b) => {
        return a.distance - b.distance
      })
      const cadEpsg = newEpsgArr[0].epsg
      console.log('cadEpsg', cadEpsg)
      return cadEpsg
      // setEpsgText(JSON.stringify(res, null, 4))
    },
    // 给加个测量的结果值
    addMarkersToPolygon (coordinates, fenceCode, style, status = false) {
      const polygon = new vjmap.Polygon({
        data: coordinates,
        fillColor: style.fillColor,
        fillOpacity: style.fillOpacity || 0.8,
        fillOutlineColor: style.fillOutlineColor
      })
      polygon.addTo(this._map)
      return polygon.sourceId
    },

    // 获取电子围栏
    loadProjectFence () {
      this.$axios.get(this.$apis.project.selectYhProjectMapByProjectId, {
        projectId: this.projectId
      }).then((res) => {
        if (res.locationList && res.locationList.length && !this.isCad) {
          const polygons = getPolygons(res.locationList)
          polygons.forEach(item => {
            this.addMarkersToPolygon(item[1], item[0], {
              fillColor: '#36cbcb',
              fillOutlineColor: '#36cbcb',
              fillOpacity: 0.5
            })
          })
        }
      })
    },

    // 获取区域详情
    selectIrrigationAreaByAreaId () {
      this.$axios.get(this.$apis.irrigation.selectJgIrrigationAreaByAreaId, {
        projectId: this.projectId,
        areaId: this.areaId,
        isCad: this.isCad ? '1' : '0'
      }).then((res) => {
        this.soilList = res.soilObjList || []
        this.waterList = res.waterObjList || []
        this.electricityList = res.electricityObjList || []
        this.valveList = res.valveObjList || []
        this.waterLyList = res.waterLyObjList || []
        this.drawMarkers()
        this.clearPolygons()
        if (res.locationList && res.locationList.length && !this.isCad) {
          const polygons = getPolygons(res.locationList)
          polygons.forEach(item => {
            const polygonId = this.addMarkersToPolygon(item[1], item[0], {
              fillColor: '#3592FE',
              fillOutlineColor: '#3592FE',
              fillOpacity: 0.5
            }, false)
            this._polygons.push(polygonId)
          })
        }
      })
    },
    loadSoilDetail (deviceNumber) {
      return this.$axios.get(this.$apis.irrigation.selectSoilInfoByDeviceNumber, {
        deviceNumber
      })
    },
    drawMarkers () {
      this.clearMarkers()
      if (this.checkValue.includes('土壤监测')) {
        this.soilList.forEach((item) => {
          this.markerAdd(item, 0)
        })
      }
      if (this.checkValue.includes('智慧水表')) {
        this.waterList.forEach((item) => {
          this.markerAdd(item, 1)
        })
      }
      if (this.checkValue.includes('智慧电表')) {
        this.electricityList.forEach((item) => {
          this.markerAdd(item, 2)
        })
      }
      if (this.checkValue.includes('电磁阀')) {
        this.valveList.forEach((item) => {
          this.markerAdd(item, 3)
        })
      }
      if (this.checkValue.includes('流压监测')) {
        console.log(11)
        this.waterLyList.forEach((item) => {
          this.markerAdd(item, 4)
        })
      }
    },
    cadToWebCoordinate (point) {
      console.log('this.cadEpsgthis.cadEpsgthis.cadEpsgthis.cadEpsg', this.cadEpsg)
      const cadEpsg = this.cadEpsg || 'EPSG:4549' // cad图的espg代号
      const co = proj4(cadEpsg, 'EPSG:4326', point)
      // 把wgs84转成高德坐标坐标
      return vjmap.transform.convert(co, vjmap.transform.CRSTypes.WGS84, vjmap.transform.CRSTypes.GCJ02)
    },
    markerAdd (item, index) {
      item.type = index
      const el = document.createElement('div')
      el.className = 'marker'
      el.style.backgroundImage = `url('${index === 3 ? this.getIconPen(item, false) : this.getIcon(item, false)}')`
      el.style.width = !item.deviceNumber ? '48px' : '36px'
      el.style.height = '48px'
      el.style.backgroundSize = '100%'
      // 有cad图层未绑定设备cad转经纬度
      // if (!item.deviceNumber) {
      // }
      if (this.isCad && item.objectX && item.objectY) {
        const cadPoints = vjmap.geoPoint([item.objectX, item.objectY])
        const lngLat = this.cadToWebCoordinate(cadPoints)
        item.longitude = lngLat[0]
        item.latitude = lngLat[1]
      }
      if (item.longitude && item.latitude) {
      const co = [item.longitude, item.latitude]
      const marker = new vjmap.Marker({
        element: el,
        anchor: 'bottom'
      })
      marker.setLngLat(co).addTo(this._map)
      if (index === 3) {
        el.addEventListener('click', (e) => {
          e.stopPropagation()
          this.drawerOpen(item)
        })
      }
      this._markers.push(marker)
      }
    },

    clearMarkers () {
      if (this._markers.length) {
        this._markers.forEach(item => item.remove())
      }
      this._markers = []
    },
    clearPolygons () {
      if (this._polygons.length) {
        this._polygons.forEach(item => this._map.removeSourceEx(item))
      }
      this._polygons = []
    },
    // 抽屉打开
    async drawerOpen (e) {
      const detail = e
      // let iconClick = null
      if ((this.drawerData && this.drawerData.deviceNumber !== detail.deviceNumber)) {
        // this.drawerClose()
        // 点击切换大图标
        switch (detail.type) {
          case 0:
            console.log('执行了呀')
            // iconClick = this.getIcon(detail, true)
            // eslint-disable-next-line no-case-declarations
            const data = await this.loadSoilDetail(detail.deviceNumber)
            data.type = detail.type
            this.drawerData = data
            console.log('data', data)
            this.openSoilDevice(data)
            this.getSoilTable(detail.deviceNumber)
            break
          case 1:
            break
          case 2:
            break
          case 3:
            this.drawerData = detail
            // iconClick = this.getIconPen(detail, true)
            break
        }
        // e.target.setOffset(new AMap.Pixel(-22, -64))
        // e.target.setIcon(iconClick)
      }
      this.drawer = true
    },

    openSoilDevice (detail) {
      // 温度
      soilInfo[0].value = detail.temperature || '--'
      soilInfo[0].status = this.getTemperatureStatus(detail.temperatureStatus)
      // 湿度
      soilInfo[1].value = detail.humidity || '--'
      soilInfo[1].status = this.getHumidityStatus(detail.humidityStatus)
      this.soilDetailInfo = soilInfo
    },

    getSoilTable (deviceNumber) {
      this.$axios.get(this.$apis.irrigation.selectSoilDataByPage, {
        deviceNumber: deviceNumber,
        page: 1,
        size: 3,
        notDesc: '1'
      }).then((res) => {
        this.tableData = res.soil.list || []
      })
    },

    getTemperatureStatus (value) {
      switch (value) {
        case '0':
          return '正常'
        case '1':
          return '过热'
        case '2':
          return '冰冻'
        default:
          return '--'
      }
    },

    getHumidityStatus (value) {
      switch (value) {
        case '0':
          return '正常'
        case '1':
          return '过涝'
        case '2':
          return '干旱'
        case '3':
          return '极度干旱'
        default:
          return '--'
      }
    },

    // 处理图标状态 bigShow:是否大图标
    getIcon (data, bigShow) {
      let icon
      if (data.type === 0) {
        if (data.deviceStatus === '1') {
          icon = data.runStatus === '1' ? (bigShow ? this.alarmWenImgCursor : this.alarmWenImg) : (bigShow ? this.onlineWenImgCursor : this.onlineWenImg)
        } else if (data.deviceStatus === '2') {
          icon = bigShow ? this.offImgWenCursor : this.offWenImg
        }
        return icon
      } else if (data.type === 2) {
        if (data.deviceStatus === '1') {
          icon = bigShow ? this.onlineDianImg : this.onlineDianImgCursor
        } else if (data.deviceStatus === '2') {
          icon = bigShow ? this.offDianImg : this.offDianImgCursor
        }
      } else if (data.type === 1) {
        if (data.deviceStatus === '1') {
          icon = bigShow ? this.onlineWaterImg : this.onlineWaterImgCursor
        } else if (data.deviceStatus === '2') {
          icon = bigShow ? this.offWaterImg : this.offWaterImgCursor
        }
      } else if (data.type === 4) {
        if (data.deviceStatus === '1') {
          icon = data.runStatus === '1' ? (bigShow ? this.alarmLyImgCursor : this.alarmLyImg) : (bigShow ? this.onlineLyImgCursor : this.onlineLyImg)
        } else if (data.deviceStatus === '2') {
          icon = bigShow ? this.offImgLyCursor : this.offLyImg
        }
      }
      return icon
    },

    // 处理图标状态 bigShow:是否大图标 开启关闭
    getIconPen (data, bigShow) {
      let icon
      // 在线
      if (data.switchStatus === '1') {
        icon = bigShow ? this.onlinePenImgCursor : this.onlinePenImg
      } else if (data.switchStatus === '0') {
        // 离线
        icon = bigShow ? this.offPenImgCursor : this.offPenImg
      }
      return icon
    },
    // 电磁阀开启关闭
    operationIrrigation (command, deviceNumber) {
      this.valveStatusUpdateLoading = this.$loading({
        lock: true,
        text: command === '1' ? '电磁阀正在开启' : '电磁阀正在关闭',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // 0 是关闭
      const info = command === '1' ? { execLength: this.irrigationInfo.duration } : {}
      this.$axios.post(this.$apis.irrigation.insertIrrigationValveRecord, {
        deviceNumber: deviceNumber,
        command: command,
        ...info
      }).then(() => {
        if (this._map && this.drawerData && this.drawerData.deviceNumber) {
          this.drawerData.switchStatus = command
        }
        this.$message.success((command === '1' ? '开启' : '关闭') + '成功')
      }).catch(() => {
        this.$message.success((command === '1' ? '开启' : '关闭') + '失败')
      }).finally(() => {
        if (this.valveStatusUpdateLoading) {
          this.valveStatusUpdateLoading.close()
        }
      })
    },

    // 关闭抽屉
    drawerClose () {
      if (this.drawer) {
        this.drawer = false
        // this.iconTab()
        this.drawerData = null
      }
    },

    // 替换图标
    iconTab () {
      if (this.map && this.drawerData) {
        const deviceNumber = this.drawerData.deviceNumber || ''
        const index = this.map.getAllOverlays('marker').findIndex((item) => item.detail.deviceNumber === deviceNumber)
        const icon = this.drawerData.type === 3 ? this.getIconPen(this.drawerData, false) : this.getIcon(this.drawerData, false)
        const marker = this.map.getAllOverlays('marker')[index]
        if (this.drawerData.longitude && this.drawerData.latitude) {
          marker.setOffset(new AMap.Pixel(-18, -48))
          marker.setIcon(icon)
        }
      }
    }

  }

}
</script>

<style scoped lang="scss">
@import '@/assets/scss/color.scss';

.el-card {
  overflow: hidden;
}

.card {
  display: flex;
  position: relative;
  height: 100%;
}

#mapContainer,
#container {
  height: 100%;
}

.tips {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 199;
  width: 140px;
  height: auto;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px 0px rgba(57, 52, 167, 0.2);
  border-radius: 20px;

  .el-checkbox-group {
    padding: 20px 20px 10px 32px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  ::v-deep .el-checkbox__label {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    height: 22px;
    margin-bottom: 10px;
  }
}

.left {
  width: 300px;
  min-width: 300px;
  min-height: 700px;
  background: #F6F8FB;
  box-shadow: 0px 1px 2px 0px rgba(139, 172, 237, 0.1);
  border-radius: 10px;
  padding: 25px 25px 25px 16px;
  margin: 0 20px 0 0;

  .area {
    display: flex;
    position: relative;

    .icon {
      position: absolute;
      color: var(--color-primary);
      top: 12px;
      display: none;
      cursor: pointer;
    }

    .el-icon-edit {
      right: 25px;
    }

    .el-icon-delete-solid {
      right: 5px;
    }

    &:hover {
      .icon {
        display: block;
      }
    }
  }

  .name,
  .add {
    display: flex;
    align-items: center;
    width: 200px;
    height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000517;
    margin-bottom: 10px;
    cursor: pointer;
    padding: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.active,
    &:hover {
      background: var(--color-primary);
      box-shadow: 0px 2px 4px 0px #E5E4FF;
      border-radius: 20px;
      color: #FFFFFF;
    }
  }
}

.drawer {
  position: absolute;
  right: -410px;
  top: 120px;
  z-index: 200;
  width: 380px;
  height: calc(100% - 130px);
  padding: 16px;
  background: #FFFFFF;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  border-left: 4px solid $color-default;
  transition: all 0.4s;
  overflow: auto;

  .data {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
  }

  .title {
    font-size: 16px;
    color: $color-font-dark;
    font-weight: 500;
    margin-bottom: 10px;
  }

  .info {
    padding-bottom: 20px;

    .text {
      font-size: 14px;
      color: $color-font-dark;
      font-weight: 500;
      line-height: 30px;
      position: relative;

      span {
        margin-left: 10px;
        color: $color-font-default;
      }

      .highlight {
        display: inline-block;
        position: absolute;
        text-align: center;
        width: 44px;
        top: -50%;
        margin-top: 20px;
        background: $color-default;
        border-radius: 2px;
        color: #fff;
        font-size: 12px;
        height: 20px;
        line-height: 20px;
      }

      .gray {
        background: #B7B7B7;
      }
    }
  }

  .line {
    border-top: 1px solid #F1F1F1;
    padding-top: 20px;
  }

  .margin20 {
    margin: 20px 0;
  }

  .info1 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .info1_div {
      display: flex;
      align-items: center;
      width: 50%;
      margin: 10px 0px;
    }

    img {
      height: 32px;
      width: 32px;
      margin-right: 10px;
    }

    .info1_bottom {
      display: flex;
      align-items: center;
    }

    .title {
      font-size: 12px;
      color: #666666;
      margin-bottom: 0px;
      word-spacing: 5px;
    }

    .icon {
      width: 32px;
      height: 32px;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin-right: 4px;
      background: linear-gradient(225deg, #6FB2FE 0%, #1B85FF 100%);
      display: flex;
      align-items: center;
      justify-content: center;

      .global-icon {
        width: 18px;
        height: 18px;
        margin-top: 7px;
        vertical-align: unset;
      }

      &.gray {
        background: linear-gradient(225deg, #D2D2D2 0%, #B7B7B7 100%);
      }

      &.warning {
        background: linear-gradient(45deg, #FF341B 0%, #FF6D6A 100%);
      }
    }

    .value {
      font-size: 20px;
      padding-right: 4px;
      font-family: 'DIN Alternate Bold';
      color: #3592FE;

      &.warning {
        color: #FF402B;
      }

      &.gray {
        color: #D2D2D2;
      }
    }

    .status {
      font-size: 11px;
      border-radius: 2px;
      width: 38px;
      height: 18px;
      text-align: center;
      padding: 0px 3px;

      &.warning {
        border: 1px solid #FF3F29;
        color: #FF3F29;
      }

      &.normal {
        border: 1px solid #52C41A;
        color: #52C41A;
      }

      &.gray {
        border: 1px solid #D2D2D2;
        color: #D2D2D2;
      }
    }
  }

  .tempAndHumi {
    display: flex;

    .temperature {
      width: 158px;
      height: 155px;
    }

    .humidity {
      width: 151px;
      height: 151px;
      margin-left: 28px;
    }
  }

  .date {
    width: 182px;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 17px;
    margin: 20px 0;
  }
}

.drawerShow {
  transform: translateX(-420px)
}

.drawerHide {
  transform: translateX(20px)
}

.right {
  margin: -20px -20px -20px 0;
  flex: 1;
  border-left: 1px solid #F4F4F4;
  padding: 20px 0 20px 20px;

  >div {
    display: flex;
    justify-content: space-around;

    &:nth-of-type(1) {
      background: #FFFFFF;
      box-shadow: 0px 2px 2px 0px rgba(119, 113, 247, 0.2);
      border-radius: 20px 20px 0px 0px;
      height: 100px;
      padding: 20px;
    }

    .header-left {
      display: flex;
      flex: 1;

      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 60px;

        .name {
          height: 22px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
        }

        .count {
          font-size: 50px;
          font-family: DINCond-Bold;
          font-weight: bold;
          color: #333333;
        }
      }
    }

    .header-right {
      display: flex;

      >div {
        display: flex;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;

        &:nth-of-type(1) {
          justify-content: center;
          display: flex;
          flex-direction: column;
          width: 76px;
        }
      }

      .plan {
        display: flex;
        width: 400px;
        flex-direction: column;
        justify-content: space-between;

        .planContent {
          display: flex;
          justify-content: space-between;
        }

        .time {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          margin-left: 22px;
        }
      }
    }
  }
}
</style>
